import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";
import { toAccountingReferenceGroupSaveValue } from "helpers/accountingReferences";
import Page from "components/page/Page";

import AccountingReferenceFields, { TAccountingReferenceFieldsState } from "./AccountingReferenceFields";
import { TAccountingReferenceApi } from "./accountingReferenceApi.types";

type AccountingReferenceNewProps = {
  api: TAccountingReferenceApi;
};

export default function AccountingReferenceNew({ api }: AccountingReferenceNewProps) {
  const history = useHistory();
  const { t } = useTranslation();

  const [accRefState, setAccRefState] = useState<TAccountingReferenceFieldsState>({
    title: "",
    reference_number: "",
    group: "none",
  });

  async function saveNewAccountingRef() {
    const res = await api.PostAccountingReference(
      { ...accRefState, group: toAccountingReferenceGroupSaveValue(accRefState.group) },
      true,
    );

    if (res.status !== StatusCode.OK) {
      return;
    }

    history.push("/admin/settings/accounting_references");
  }

  return (
    <Page
      title={t("New Accounting Reference")}
      narrow
      primaryAction={{ content: t("Save"), action: saveNewAccountingRef }}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Accounting References"),
          url: "/admin/settings/accounting_references",
        },
      ]}
    >
      <AccountingReferenceFields value={accRefState} onChange={setAccRefState} />
    </Page>
  );
}
